interface Props {
  title: string;
  description?: string;
  children: React.ReactNode;
}

export const Counter: React.FC<Props> = ({ children, title, description }) => {
  return (
    <div className="col-span-3 shadow-md bg-white p-5 lg:h-44 md:h-36 h-full space-y-2 flex flex-col justify-between rounded-lg text-gray-600 hover:text-white hover:bg-primary-500 transition-colors duration-300 md:text-left text-center">
      {children}
      <div className="lg:space-y-2 space-y-1">
        <div className="font-semibold lg:text-base text-sm">{title}</div>
        <div className="text-sm">{description}</div>
      </div>
    </div>
  );
};
